import styled from "@emotion/styled";
import { alpha, Avatar, Badge, Box, List, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles/createTheme";
import theme from "../theme";

export const SidebarWidth = 60;

export const RailAction = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const RailLabel = styled(Typography)`
  font-size: 9px;
  line-height: 1.1;
  color: ${({ theme: t }) => (t as Theme).palette.common.white};
  margin-top: -6px;
  padding-bottom: 4px;
  text-align: center;
`;

export const StyledBadge = styled(Badge)`
  & .MuiBadge-badge {
    box-shadow: 0 0 0 2px ${theme.palette.background.paper};
    font-size: 0.6rem;
    min-width: 14px;
    height: 14px;
    padding: 0 3px;
  }
`;

export const SidebarWrapper = styled(Box)`
  width: ${SidebarWidth}px;
  flex: 0 0 ${SidebarWidth}px;
  box-sizing: border-box;
  border-right: 1px solid ${({ theme }) => (theme as Theme).palette.divider};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  background: ${({ theme }) => (theme as Theme).palette.primary.main};
`;

export const CompanyLogoAvatar = styled(Avatar)``;

export const BottomBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => (theme as Theme).palette.common.white};
`;

export const CustomAvatar = styled(Avatar)`
  border-radius: 3px;
  text-transform: capitalize;
  font-size: 0.8rem;
  border: 1px solid
    ${({ theme }) => alpha((theme as Theme).palette.common.white, 0.5)};
`;

export const OrgTile = styled(Box)`
  position: relative;
  display: flex;
`;

// Sits outside the avatar because MUI's Avatar clips its children with
// overflow: hidden; the bottom-left corner is already taken by the socket dot.
export const PendingMarker = styled(Box)`
  position: absolute;
  right: -5px;
  bottom: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ theme }) => (theme as Theme).palette.common.white};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SidebarListWrapper = styled(List)`
  width: 100%;
  max-width: ${SidebarWidth}px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  scrollbar-width: none;
  padding: 0;
  border-top: 1px solid
    ${({ theme }) => alpha((theme as Theme).palette.background.default, 0.4)};
  border-bottom: 1px solid
    ${({ theme }) => alpha((theme as Theme).palette.background.default, 0.4)};
`;
